
import { assign } from 'lodash';
import { updateArray } from "../../../helpers/index";
import { ActionType, IAction } from '../actions/actions';
import { IFilter } from '../../../classes/filter';
import { IMediaGalleryItem } from '../../../classes/media-gallery';

export interface FilterModel {
    filters: { [key: string]: Function };
    combinedFilter: (it: IMediaGalleryItem) => boolean;
};

export const defaultFilterModel: FilterModel = {
    filters: {},
    combinedFilter: () => true
};

export default function filterReducer(state: FilterModel = defaultFilterModel, action: IAction) {
    switch (action.type) {
        case ActionType.UPSERT_FILTER: {
            const value = action.value as IFilter;

            const newFilters = assign({}, state.filters);
            newFilters[value.key] = value.func;

            const filterFunction = (it: IMediaGalleryItem) => Object.keys(newFilters).map(key => newFilters[key]).every(func => func(it));

            return assign({}, state, {
                filters: newFilters, combinedFilter: filterFunction
            });
        }

        case ActionType.REMOVE_FILTER: {
            const value = action.value as string;

            const newFilters = assign({}, state.filters);
            delete newFilters[value];
            const filterFunction = (it: IMediaGalleryItem) => Object.keys(newFilters).map(key => newFilters[key]).every(func => func(it));

            if (Object.keys(newFilters).length === 0) {
                return assign({}, state, {
                    filters: newFilters, combinedFilter: (it: IMediaGalleryItem) => true
                });
            }

            return assign({}, state, {
                filters: newFilters, combinedFilter: filterFunction
            });
        }

        case ActionType.REMOVE_ALL_FILTERS: {
            return assign({}, state, {
                filters: {}, combinedFilter: (it: IMediaGalleryItem) => true
            });
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./app/media-gallery/redux/reducers/filters.ts